import React from "react";
import {
  lifecycle,
  compose,
  branch,
  renderNothing,
  renderComponent,
  withProps
} from "recompose";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actions } from "../../modules/dealers";
import TryAgain from "../../components/TryAgain";
import Loading from "../../components/Loading";

const failed = ({
  failFetchDealers,
  fetchingDealers,
  successFetchDealers,
  dealers
}) => !fetchingDealers && failFetchDealers && !successFetchDealers && !dealers;
const isFetching = ({
  fetchingDealers,
  failFetchDealers,
  successFetchDealers,
  dealers
}) => fetchingDealers && !failFetchDealers && !successFetchDealers && !dealers;
const isInitial = ({
  failFetchDealers,
  fetchingDealers,
  successFetchDealers,
  dealers
}) => !failFetchDealers && !fetchingDealers && !successFetchDealers && !dealers;
const dealersIsNull = ({ dealers }) => !dealers;

const TryAgainDealer = ({ failFetchDealers, fetchDealers }) => (
  <TryAgain label={failFetchDealers} onTryAgain={fetchDealers} />
);

const nonOptimalStates = states =>
  compose(...states.map(state => branch(state.when, state.render)));

export const withFetchingStates = nonOptimalStates([
  {
    when: isFetching,
    render: renderComponent(withProps({ label: "Loading Dealers" })(Loading))
  },
  { when: failed, render: renderComponent(TryAgainDealer) },
  { when: isInitial, render: renderNothing },
  { when: dealersIsNull, render: renderNothing }
]);

export const withFetchDealers = lifecycle({
  componentDidMount() {
    const { dealers, fetchDealers, user } = this.props;
    if (user) {
      !dealers && fetchDealers();
    }
  },
  componentWillUnmount() {
    this.props.resetState();
  }
});

const mapStateToProps = state => ({
  ...(state.dealers || {}),
  user: state.auth.user
});
const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(actions, dispatch),
  dispatch
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFetchDealers,
  withFetchingStates
);
